define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseTableViewController = require('web-agent-framework/BaseTableViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var EngagementsHistoryTableWidgetsManager = require('web-agent-viewControllers/EngagementsHistoryTableWidgetsManager');
    var EngagementsHistoryEngagementWidget = require('web-agent-widgets/EngagementsHistoryEngagementWidget');
    var EngagementsHistoryVisitInfoWidget = require('web-agent-widgets/EngagementsHistoryVisitInfoWidget');
    var FilterButtonSelectViewController = require('web-agent-components/FilterButtonSelectViewController');
    var FilterMcsViewController = require('web-agent-components/FilterMcsViewController');
    var FilterTimeFrameViewController = require('web-agent-components/FilterTimeFrameViewController');
    var FilterDropdownSelectionViewController = require('web-agent-components/FilterDropdownSelectionViewController');
    var FilterDurationViewController = require('web-agent-components/FilterDurationViewController');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');

    var MAX_EXPORT_ITEMS = 100000;

    var EngagementsHistoryTableViewController = BaseTableViewController.extend({
        ControllerName: "EngagementsHistoryTableViewController",
        applicationType: "EngagementsHistoryTableViewController",

        focusedName: "EngagementsHistoryTable",

        LPViewMap: {
        },

        //the text is the text languino key
        LPSearchFilterOptions: {
            TRANSCRIPT :
                {id: "transcript", text: "history_search_filter_transcript"},
            SURVEYS :
                {id: "surveys", text: "history_search_filter_surveys"},
            SDES :
                {id: "SDES", text: "history_search_filter_SDEs"},
            VISITORINFO :
                {id: "visitorInfo", text: "history_search_filter_visitor_info"},
            SEPARATOR :
                {id: "separator", text: ""},
            CHATID :
                {id: "chatID", text: "history_search_filter_chat_ID"}
        },

        LPPrefixMap: {
            engagementsHistory: "ENGAGEMENTS_HISTORY"
        },

        initialize: function () {
        },

    events : function () {
            this.bindModel({modelPath: this.tableItemsStateModelPath, callback: this.handleTableStateChanged});
            this.bindModel({
                modelPath: this.getConfiguration().tableRootModelPath + ".lastQuery.searchTag",
                callback: this.handleSearchValueChanged
            });
            this.bindModel({
                modelPath: this.getConfiguration().tableRootModelPath + ".lastQuery.searchArea",
                callback: this.handleSearchValueChanged
            });
        },

        render: function () {
        }
    });

EngagementsHistoryTableViewController.prototype.getModelControllerInstance = function () {
    return lpTag.WebAgent.engagementsHistoryTableController;
};

EngagementsHistoryTableViewController.prototype.handleSearchValueChanged = function () {
    var mc = this.getModelControllerInstance();
    if (isSearchByEngagementMode(mc) && this.filterStatusEnable) {
        this.filterStatusEnable = false;
        this.setHeaderFiltersStatus(false);
    }
    else if (!isSearchByEngagementMode(mc) && !this.filterStatusEnable) {
        this.filterStatusEnable = true;
        this.setHeaderFiltersStatus(true);
    }
};

/**
 *
 * @param mc - model controller
 * @returns {boolean} - true - if the searchTag is not empty and also the searchArea is "chatId", false - otherwise
 */
function isSearchByEngagementMode(mc) {
    return (mc.getModelParam("engagementsHistory.lastQuery.searchArea") === "chatId") && (mc.getModelParam("engagementsHistory.lastQuery.searchTag") !== "");
}

EngagementsHistoryTableViewController.prototype.getConfiguration = function () {
    var modelController = this.getModelControllerInstance();
    var configuration = {
        updateQueryCallback : modelController.updateQuery,
        context : this,
        textsPrefix : this.LPPrefixMap.engagementsHistory,
        tableName : this.applicationType,
        tableRootModelPath : "engagementsHistory",
        globalData : {
            modelController : modelController,
            tableName : this.applicationType,
            textsPrefix : this.LPPrefixMap.engagementsHistory
        },
        tableHead : {
            defaultSortTag : modelController.getDefaultValue("sortTag"),
            defaultSortOrder : modelController.getDefaultValue("sortOrder"),
            columnsData : [
                {
                    title : "visitorName",
                    tooltip : "visitorNameTooltip"
                },{
                    title : "skill",
                    tooltip : "skillTooltip",
                    filter: {
                        filterManager: FilterDropdownSelectionViewController,
                        filterManagerData: {
                            className: "filter_dropdown_selection_view",
                            filterName: "skillIds",
                            filterTextSuffix: "skills",
                            filterDataModelPath: "skills.array",
                            textProperty: "name",
                            minusOneData: {"id": -1 , "name" : this.translate('unassigned')}
                        }
                    }
                },{
                    title : "pastChatAgentName",
                    tooltip : "pastChatAgentNameTooltip",
                    filter: {
                        filterManager: FilterDropdownSelectionViewController,
                        filterManagerData: {
                            className: "filter_dropdown_selection_view",
                            filterName: "agentIds",
                            filterTextSuffix: "agents",
                            filterDataModelPath: "operators.array",
                            textProperty: "displayName",
                            floating: false,
                            toggleButton: agentLEManager.getLEConfig().supportDeletedUsers && {
                                toggleByField: {
                                    fieldName: 'deleted',
                                    lineSubText: this.translate('filter_deleted_indication'),
                                },
                                checked: false
                            },
                            label: agentLEManager.getLEConfig().supportDeletedUsers && this.translate('filter_deleted_agents_title')
                        }
                    }
                },{
                    title: "activeChatAgentGroup",
                    tooltip: "activeChatAgentGroupTooltip",
                    filter: {
                        filterManager: FilterDropdownSelectionViewController,
                        filterManagerData: {
                            className: "filter_dropdown_selection_view",
                            filterName: "agentGroupIds",
                            filterTextSuffix: "agentGroups",
                            filterDataModelPath: "agent.agentGroups.array",
                            textProperty: "displayName"
                        }
                    }
                },{
                    mcsImage: "mcsImage" // show no title
                },{
                    title : "filter_title_mcs",
                    tooltip : "sentimentTooltip",
                    filter: {
                        filterManager: FilterMcsViewController,
                        filterManagerData: {
                            filterName: "mcs",
                            filterTextSuffix: "mcs"
                        }
                    }
                },{
                    sortTag : "start",
                    title : "chatStart",
                    tooltip : "chatStartTooltip",
                    tooltipAlign : "left",
                    filter: {
                        filterManager: FilterTimeFrameViewController,
                        filterManagerData: {
                            className: "filter_time_frame_view",
                            filterName: "chatStart",
                            defaultFilter:{startDate: modelController.getDefaultValue("chatStart.startTime"), endDate:modelController.getDefaultValue("chatStart.endTime")},
                            defaultFilterIsActive: true
                        }
                    }
                },{
                    sortTag : "duration",
                    title : "engLength",
                    tooltip : "engLengthTooltip",
                    filter : {
                        filterManager: FilterDurationViewController,
                        filterManagerData: {
                            className: "filter_duration_view",
                            filterName: "duration"
                        }
                    }
                },{
                    title : "startPage",
                    tooltip : "startPageTooltip"
                },{
                    title : "device",
                    tooltip : "deviceTooltip",
                    //sortTag : "device",
                    filter: {
                        filterManager: FilterButtonSelectViewController,
                        filterManagerData: {
                            filterName: "device",
                            filterTextSuffix: "device",
                            buttons: [
                                {
                                    status      : "DESKTOP",
                                    buttonId    : "DESKTOP",
                                    iconClass  : "device",
                                    iconType    : "DESKTOP",
                                    buttonText  : "{{VISIT_INFO_Device_DESKTOP}}"
                                },{
                                    status      : "TABLET",
                                    buttonId    : "TABLET",
                                    iconClass  : "device",
                                    iconType    : "TABLET",
                                    buttonText  : "{{VISIT_INFO_Device_TABLET}}"
                                },{
                                    status      : "MOBILE",
                                    buttonId    : "MOBILE",
                                    iconClass  : "device",
                                    iconType    : "MOBILE",
                                    buttonText  : "{{VISIT_INFO_Device_MOBILE}}"
                                }
                            ]
                        }
                    }
                }

            ]
        },
        tableBody : {
            htmlTable: true,
            ignoreRowHover: true,
            ignoreSectionHover: true,
            rowTemplateFile : 'LP_engagements_history_table_row.html',
            dataRenderer : this.dataRenderer,
            supportKeysNavigation : true
        },
        paging : {
            pageSize : modelController.getDefaultValue("limit")
        },
        widgets : {
            widgetsManager : EngagementsHistoryTableWidgetsManager,
            widgetsManagerData : {
                className : "engagements_history_widgets",
                autoHideButtonsToolbar: false,
                itemIdTag : "engagementId",
                widgetsData : [
                    {
                        widgetType: EngagementsHistoryEngagementWidget,
                        widgetData: {
                            itemIdTag: "engagementId",
                            bindToChatModel: false,
                            widgetMode: 'History',
                            chatsRootModelPath: 'engagementsHistory.data'
                        }
                    },{
                        widgetType: EngagementsHistoryVisitInfoWidget,
                        widgetData: {
                            itemIdTag: "engagementId",
                            rootModelPath: 'engagementsHistory.data'
                        }
                    }
                ]
            }
        },
    filterStatusEnable: true};
    configuration.tableSearch = {
        actionType: "filter", //activating filtering in the search box
        filterItems: this.getFilterSearchItems(),
        filterDefaultSelection: this.getFilterSearchDefaultItems(),
        LPSearchFilterOptions: this.LPSearchFilterOptions,
        iconId: 99, //TODO take from someplace?
        afterTitle: "",
        searchFilterEventCallback: true, //fire a special event and not the default filter event
        alphaOption: this.LPSearchFilterOptions.CHATID.id //send this if there is an option that should disable all others if it's selected
    };
    configuration.tableActions = {
        actionDropdownArray: [
            {
                id: "exportToCsv",
                actionName: this.translate("ENGAGEMENTS_HISTORY_action_webHistoryExportToCsv"),
                enabled: true,
                align: "right",
                callbackFunc: _.bind(this.exportToCsv, this)

                },
                {
                    id: "exportToJson",
                    actionName: this.translate("ENGAGEMENTS_HISTORY_action_webHistoryExportToJson"),
                    enabled: true,
                    align: "right",
                    callbackFunc: _.bind(this.exportToJson, this)
                }]
        };

        if (agentLEManager.hasDataEncryptionFeature()) {
            configuration.tableSearch.isEncrypted = true;
        }
        if (!lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
            configuration.tableHead.headerRowClassName += " hide_agentGroups";
        }
        if (!lpTag.WebAgent.logicController.hasSentimentAnalysisFeature()) {
            configuration.tableHead.headerRowClassName = "hide_sentiment";
        }
        return configuration;
    };

//actions:

    EngagementsHistoryTableViewController.prototype.exportToJson = function () {
        this.modelController.exportToJson();
    };
    EngagementsHistoryTableViewController.prototype.exportToCsv = function () {
        this.modelController.exportToCsv();
    };

    EngagementsHistoryTableViewController.prototype.handleTableStateChanged = function (data) {
        function afterFetch() {
            if (data.newValue.itemsCount <= MAX_EXPORT_ITEMS) {
                this.tableActions.setActionAvailability("exportToCsv", true, "ENGAGEMENTS_HISTORY_action_webHistoryExportToCsv_tooltip");
                this.tableActions.setActionAvailability("exportToJson", true, "ENGAGEMENTS_HISTORY_action_webHistoryExportToJson_tooltip");
            } else {
                this.tableActions.setActionAvailability("exportToCsv", false, "ENGAGEMENTS_HISTORY_action_tooltip_too_many_records");
                this.tableActions.setActionAvailability("exportToJson", false, "ENGAGEMENTS_HISTORY_action_tooltip_too_many_records");
            }
        }
        if (data && data.newValue) {
            switch (data.newValue.status) {
                case "fetching":
                    break;// do nothing
                case "fetched":
                    afterFetch.call(this);
                    break;
                default:
                    afterFetch.call(this);
            }
        }
    };

//return an object that contains the search itmes by id and text
    EngagementsHistoryTableViewController.prototype.getFilterSearchItems = function () {
        var resultArray = [];
        for (var option in this.LPSearchFilterOptions) {
            if (this.LPSearchFilterOptions.hasOwnProperty(option)) {
                var obj = this.LPSearchFilterOptions[option];
                if (obj.id && obj.text) {
                    if (obj.id !== this.LPSearchFilterOptions.TRANSCRIPT.id || lpTag.WebAgent.logicController.isSearchOnTranscriptEnabled()) {
                        resultArray.push({"id": obj.id, "text": this.translate(obj.text)});
                    }
                } else if (obj.id === this.LPSearchFilterOptions.SEPARATOR.id) {
                    resultArray.push({"id": "separator", "text": ""});
                }
            }
        }
        return resultArray;
    };

    EngagementsHistoryTableViewController.prototype.getFilterSearchDefaultItems = function () {
        if (lpTag.WebAgent.logicController.isSearchOnTranscriptEnabled()) {
            return this.LPSearchFilterOptions.TRANSCRIPT.id;
        } else {
            return (this.LPSearchFilterOptions.SURVEYS.id);
        }
    };

EngagementsHistoryTableViewController.prototype.dataRenderer = {
    numberOfSections: function(data) {
        return 1;
    },
    numberOfRowsInSection: function(data, sectionIndex) {
        return data.length;
    },
    dataForSection: function(data, sectionIndex) {
        // The data will be injected to the section template.
    },
    dataForRowInSection: function(data, rowIndex, sectionIndex) {
        var participantInfo = data[rowIndex].participantInfo;
        var visitorInfo = data[rowIndex].visitorInfo;
        var value = {};
        if (participantInfo) {
            value.id = participantInfo.engagementId;
            value.darkLine = rowIndex % 2 === 0 ? 'dark_line' : '';
            if (participantInfo.startTimeL) {
                value.startTime = lpUtils.formatDateAsString(new Date(participantInfo.startTimeL));
            }
            if (participantInfo.skillName) {
                // handle -1 skill id and deleted skill id's that will not exist in skill list
                value.skillTooltip = participantInfo.skillName;
                value.skill = participantInfo.skillName;
            }

            value.agentNameTooltip = participantInfo.agentName;
            value.agentName = participantInfo.agentName;
            value.agentDeleted = participantInfo.agentDeleted ? this.translate("agent_deleted_indication") + ' ' : '';

            value.visitorName = participantInfo.visitorName || "";
            value.visitorNameTooltip = participantInfo.visitorName || "";
            if (typeof participantInfo.duration!== "undefined") {
                var engLengthTexts = lpTag.WebAgent.logicController.getFormatDurationTime(participantInfo.duration * 1000);
                value.engLength = engLengthTexts.text;
                value.engLengthTooltip = engLengthTexts.tooltip;
            }
            if (typeof participantInfo.isInteractive !== "undefined") {
                if (participantInfo.isInteractive) {
                    value.checked = "checked";
                    value.isInteractiveTooltip = this.translate("interactiveChatTooltip");
                } else {
                    value.checked = "";
                }
            }

            value.startPage = participantInfo.chatStartPage || this.translate('pageHasNoTitle');
            value.startUrl = participantInfo.chatStartUrl || "";

                if (lpTag.WebAgent.logicController.hasAgentGroupsColumn()) {
                    if (participantInfo.agentGroupId && participantInfo.agentGroupName !== "") {
                        value.agentGroup = participantInfo.agentGroupName;
                        value.agentGroupTooltip = participantInfo.agentGroupName;
                    } else {
                        value.agentGroup = this.translate('notAvailable');
                        value.agentGroupTooltip = this.translate('notAvailable');
                    }
                } else {
                    value.className += " hide_agentGroups";
                }

                if (lpTag.WebAgent.logicController.hasSentimentAnalysisFeature()) {
                    value.mcs = value.messageRawScore = typeof participantInfo.chatMCS === "number" ? participantInfo.chatMCS : "";
                    if (participantInfo.sentimentScore !== 'undefined') {
                        var sentimentTag = lpTag.WebAgent.logicController.getSentimentTag(participantInfo.mcs);
                        value.sentiment = this.LPClassesMap[sentimentTag];
                    } else {
                        value.sentiment = "neutral";
                    }
                } else {
                    value.className += "hide_sentiment";
                }
                if (value.sentiment === "neutral") {
                    value.sentimentTooltip = '';
                } else {
                    value.sentimentTooltip = this.translate('SENTIMENT_' + value.sentiment);
                }
            }
            value.deviceTypeTooltip = "";
            if (visitorInfo) {
                if (visitorInfo.device) {
                    value.deviceTypeTooltip = visitorInfo.device;
                    value.deviceType = visitorInfo.device;
                }
            }

            return value;
        }
    };

    return EngagementsHistoryTableViewController;

});
